import type { FaireProductEntity } from "../../entity_types/product";

export const p_edgxed2j83: FaireProductEntity = {
  token: "p_edgxed2j83",
  type: "product",
  name: "Lina Chain",
  brandToken: "b_p84a4prujf",
  brandName: "Kate Lauren",
  imageUrl: "https://cdn.faire.com/fastly/26a44dc52783e815fed2a1ff4d458ef3b765c09defe0366a5af83727de7d0cc9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ff590574bead2d44764434ef2097eb64d9df1bca229c14a97832d98c3d4cc966.jpeg"
  ],
  priceDollars: 39,
  description: "Our signature 17.5” chunky 12k antiqued gold ball chain with a large toggle clasp.\n\nPerfect to wear alone or with a charm.\n\n• Cast in New Jersey and assembled in Berkeley, CA.\n• Made with a high-quality 12k antiqued gold overlay on pewter.\n• Pewter components are made of high-quality pewter that is free of lead and cadmium.",
  tags: [],
  msrpDollars: 78,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-14T17:06:53.878Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
